<template>
  <a-locale-provider :locale="zh_CN">
    <a-modal
      centered
      :title="title"
      v-model="visible"
      :maskClosable="false"
      @ok="onSubmit"
      @cancel="onCancel"
      :confirmLoading="confirmLoading"
      :okButtonProps="{
        props: {
          disabled: actionType == 'check'
        }
      }"
      width="60%"
      ><a-spin :spinning="spinning">
        <data-form
          ref="form"
          :content="content"
          :data="formData"
          :fixedLabelWidth="true"
          :colnum="3"
          :showButton="false"
          style="width:100%;"
        >
          <template slot="relatedOrderNo">
            <a-button type="link" @click="jumpToOrder">{{
              relatedOrderNo
            }}</a-button>
          </template>
        </data-form>
        <div class="order-info" v-if="relatedOrderNo">
          <span class="name"> 订单扣减信息：</span>
          <span style="flex:1">{{ relatedOrderInfo }}</span>
        </div>
        <div style="padding-left:100px;margin-top:5px">
          <a-button
            type="primary"
            style="margin-bottom:10px"
            @click="addGoods"
            v-if="actionType !== 'check'"
            :disabled="!selWarehouseId"
            >添加</a-button
          ><span
            v-if="actionType !== 'check'"
            style="color: #f60;  margin-left: 5px;"
            >（数量、单价和金额可点击表格编辑）</span
          >
          <data-grid
            class="custom-grid"
            style="overflow: auto;width:95%"
            :columns="columns"
            :rowAction="false"
            rowKey="key"
            v-model="goodsData"
            :props="{
              scroll: {
                y: 260
              }
            }"
            bordered
          >
          </data-grid>
          <div class="total-info">
            总数量：<span>{{ totalNum }}</span> 总金额：<span>{{
              totalMoney
            }}</span>
          </div>
        </div>
      </a-spin>
      <OrderDetail ref="restaurantOrderDetail" :operation="false"></OrderDetail>
    </a-modal>
  </a-locale-provider>
</template>

<script>
import { DataForm } from "@/components/dataForm";
import { DataGrid } from "@/components/dataGrid";
// import cloneDeep from "lodash/cloneDeep";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import { accMul, accDiv } from "@/utils/common";
import moment from "moment";
import { GoodsAddModal } from "./../index.js";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
import OrderDetail from "@/views/restaurant/OrderDetail";
import { NoStayOrderDetailModal } from "@/views/orderManage/noStayOrder/index.js";
import calc from "@/utils/calc.js";
export default {
  name: "OrderAccounts",
  components: { DataForm, DataGrid, OrderDetail },
  props: {
    api: {
      type: String,
      default: "NonRoomOrder_Add"
    },
    orderId: {
      type: String,
      default: ""
    },
    actionType: {
      type: String,
      default: "add"
    },
    type: {
      type: String,
      default: "instock"
    },
    title: {
      type: String,
      default: "新增"
    },
    update: {
      type: Function
    }
  },
  data() {
    return {
      zh_CN,
      visible: false,
      confirmLoading: false,
      formData: {},
      content: [],
      goodsData: [],
      spinning: false,
      columns: [
        {
          title: "序号",
          width: "12%", //宽度
          align: "center", //对齐方式
          type: "indexcolumn" // 类型，indexcolumn = 序号
        },
        {
          title: "物品名称",
          dataIndex: "GoodsName"
        },
        {
          title: "单位",
          dataIndex: "GoodsUnitName",
          width: "12%"
        },
        {
          title: "数量",
          dataIndex: "Quantity",
          width: "12%",
          edit: {
            type: "number"
          },
          min: 0,
          max: 1000000,
          onChange: (data, record) => {
            const value = this.convertNumber(data);
            record.Quantity = value;
            this.caculateTotalPrice(data, record);
            this.caculateTotal();
          }
        },
        {
          title: "单价",
          dataIndex: "UnitPrice",
          width: "12%",
          align: "right",
          edit: {
            type: "number"
          },
          min: 0,
          max: 1000000,
          onChange: (data, record) => {
            const value = this.convertNumber(data);
            record.UnitPrice = value;
            this.caculateTotalPrice(data, record);
            this.caculateTotal();
          }
        },
        {
          title: "金额",
          dataIndex: "TotalPrice",
          width: "12%",
          align: "right",
          edit: {
            type: "number"
          },
          min: 0,
          max: 1000000,
          onChange: (data, record) => {
            const value = this.convertNumber(data);
            record.TotalPrice = value;
            this.caculateUnitPrice(data, record);
            this.caculateTotal();
          }
        },
        {
          title: "操作",
          width: "15%",
          customRender: (text, record, index) => {
            const del = {
              click: () => {
                this.del(index);
              }
            };
            let link = (
              <a-button type="link" size="small" {...{ on: del }}>
                删除
              </a-button>
            );
            if (this.actionType == "check") {
              link = "";
            }
            return link;
          }
        }
      ],
      billDetail: {},
      selWarehouseId: "",
      orderCategory: "",
      relatedOrderNo: "",
      relatedOrderId: "",
      relatedOrderInfo: "",
      totalNum: 0,
      totalMoney: 0,
      defaultItem: {}
    };
  },
  created() {
    this.visible = true;
    if (this.actionType == "add") {
      this.getBillNo();
    } else if (this.actionType == "update" || this.actionType == "check") {
      this.getBillDetail();
    }
    const baseContent = [
      {
        label: "单号",
        name: "BillNo",
        props: {
          disabled: true
        }
      },
      {
        label: "收货日期",
        name: "BillDate",
        type: "date",
        props: {
          disabled: this.actionType == "check",
          disabledDate: current => current && current < moment().startOf("day")
        }
      },
      {
        type: null
      }
    ];
    let addContent = [];
    if (this.type == "instock" || this.type == "refund") {
      addContent = [
        {
          label: "供应商",
          name: "SupplierId",
          type: "select",
          api: "Common_GetSelect",
          param: {
            Types: "Supplier"
          },
          dataField: "Data.Supplier",
          option: {
            rules: [{ required: true, message: "请选择供应商" }]
          },
          props: {
            disabled: this.actionType == "check"
          },
          load: data => {
            if (data && data.length == 1 && this.actionType == "add") {
              this.formData = {
                ...this.formData,
                SupplierId: data[0].Id
              };
            }
          }
        },
        this.getWarehouseLabel("仓库", "WarehouseId")
      ];
    } else if (this.type == "outstock") {
      addContent = [
        {
          label: "部门",
          name: "DepartmentId",
          type: "select",
          api: "Common_GetSelect",
          param: {
            Types: "Department"
          },
          dataField: "Data.Department",
          option: {
            rules: [{ required: true, message: "请选择部门" }]
          },
          props: {
            disabled: this.actionType == "check"
          }
        },
        this.getWarehouseLabel("仓库", "WarehouseId")
      ];
    } else if (this.type == "transfer") {
      addContent = [
        this.getWarehouseLabel("调出仓库", "WarehouseId"),
        this.getWarehouseLabel("调入仓库", "InWarehouseId")
      ];
    }
    this.content = baseContent.concat(addContent).concat([
      {
        type: null
      },
      {
        label: "备注",
        colnum: 2,
        name: "Remark",
        props: {
          disabled: this.actionType == "check"
        }
      }
    ]);
    if (
      (this.type == "instock" || this.type == "outstock") &&
      this.actionType !== "add"
    ) {
      this.content = this.content.concat({
        label: "关联订单",
        slot: "relatedOrderNo"
      });
    }
    this.$post("Room_GetDefaultTime", {}).then(res => {
      res.Data.SystemConstList.forEach(item => {
        this.defaultItem[item.Code] = item.Value;
      });
    });
  },
  methods: {
    caculateTotal() {
      if (this.goodsData && this.goodsData.length) {
        let number = 0,
          money = 0;
        this.goodsData.forEach(el => {
          // number = accAdd(number, el.Quantity);
          number = calc(number)
            .add(el.Quantity)
            .number(2);
          // money = accAdd(money, el.TotalPrice);
          money = calc(money)
            .add(el.TotalPrice)
            .number(2);
        });
        this.totalNum = Number(number);
        this.totalMoney = money;
      }
    },
    convertNumber(data) {
      const arr = data && String(data).split(".");
      if (arr && arr[1] && arr[1].length > 2) {
        data = Number(data).toFixed(2);
      }
      return data;
    },
    getWarehouseLabel(label, name) {
      return {
        label: label,
        name: name,
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "Warehouse"
        },
        dataField: "Data.Warehouse",
        option: {
          rules: [{ required: true, message: "请选择仓库" }]
        },
        props: {
          disabled: this.actionType == "check"
        },
        onChange: sel => {
          if (name == "WarehouseId") {
            this.selWarehouseId = sel;
          }
        },
        load: data => {
          if (name == "WarehouseId") {
            if (data && data.length == 1 && this.actionType == "add") {
              this.selWarehouseId = data[0].Id;
              this.formData = {
                ...this.formData,
                [name]: data[0].Id
              };
            }
          }
        }
      };
    },
    onCancel() {
      this.$emit("destroy");
    },
    del(index) {
      this.goodsData.splice(index, 1);
    },
    getBillNo() {
      this.spinning = true;
      this.$post("Warehouse_BillNoGet", {})
        .then(res => {
          this.$nextTick(() => {
            this.formData = {
              ...this.formData,
              BillNo: res.Data,
              BillDate: moment().format("YYYY-MM-DD")
            };
          });
          setTimeout(() => {
            this.spinning = false;
          }, 100);
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    getBillDetail() {
      this.spinning = true;
      this.$post("Warehouse_BillDetail", { Id: this.orderId })
        .then(res => {
          this.billDetail = res.Data;
          const master = res.Data.Master;
          this.selWarehouseId = master.WarehouseId;
          this.relatedOrderId = master.RelatedOrderId;
          this.relatedOrderNo = master.RelatedOrderNo;
          this.orderCategory = master.OrderCategory;
          this.relatedOrderInfo = master.RelatedOrderInfo;
          if (
            !this.relatedOrderId &&
            (this.type == "instock" || this.type == "outstock")
          ) {
            this.content.splice(this.content.length - 1, 1);
          }
          this.$nextTick(() => {
            this.formData = {
              BillNo: master.BillNo,
              BillDate: master.BillDate,
              SupplierId: master.SupplierId,
              WarehouseId: master.WarehouseId,
              InWarehouseId: master.InWarehouseId,
              DepartmentId: master.DepartmentId,
              Remark: master.Remark
            };
          });

          this.goodsData = res.Data.Details.map((v, index) => {
            v.key = index;
            return v;
          });
          this.caculateTotal();
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    jumpToOrder() {
      // this.visible = false;
      // cache.set("bill_relatedOrder", this.relatedOrderNo);
      if (this.relatedOrderId && this.relatedOrderId != "0") {
        if (this.orderCategory == 1) {
          //餐饮
          this.$refs.restaurantOrderDetail.show(this.relatedOrderId);
        } else if (this.orderCategory == 2) {
          //非住订单
          NoStayOrderDetailModal({
            orderId: this.relatedOrderId,
            showBtn: false
          });
        } else {
          //酒店订单
          if (this.defaultItem.PlusHotelOrderModel == 1) {
            TeamOrderDetailModal({
              orderId: this.relatedOrderId,
              showBtn: false
            });
          } else {
            OrderDetailModal({
              orderId: this.relatedOrderId,
              showBtn: false
            });
          }
        }
      }
    },
    addGoods() {
      GoodsAddModal({
        WarehouseId: this.selWarehouseId,
        type: this.type,
        update: datas => {
          this.goodsData = this.goodsData.concat(datas);
          this.goodsData = this.goodsData.map((v, index) => {
            v.key = index;
            return v;
          });
          this.caculateTotal();
        }
      });
    },
    caculateTotalPrice(data, record) {
      record.TotalPrice = accMul(record.Quantity, record.UnitPrice).toFixed(2);
    },
    caculateUnitPrice(data, record) {
      if (record.Quantity != 0) {
        record.UnitPrice = accDiv(record.TotalPrice, record.Quantity).toFixed(
          2
        );
      }
    },
    onSubmit() {
      this.confirmLoading = true;
      const form = this.$refs.form.form;
      form.validateFields((err, values) => {
        if (!err) {
          let params = {};
          params.Master = {
            ...values
          };
          if (!this.goodsData.length) {
            this.$message.error("请先添加物品信息!");
            this.confirmLoading = false;
            return false;
          }
          const zeroData = this.goodsData.every(field => field.Quantity !== 0);
          if (!zeroData) {
            this.$message.error("存在数量为0的物品，请先填写物品数量!");
            this.confirmLoading = false;
            return false;
          }
          params.Details = this.goodsData.map(v => {
            const json = {
              GoodsId: v.GoodsId,
              Quantity: v.Quantity,
              UnitPrice: v.UnitPrice,
              TotalPrice: v.TotalPrice
            };
            if (this.actionType == "update" && !v.isAdd) {
              json.Id = v.Id;
            }
            return json;
          });
          if (this.actionType == "update") {
            params.Master.Id = this.billDetail.Master.Id;
          }
          this.$post(this.api, params)
            .then(() => {
              this.visible = false;
              this.confirmLoading = false;
              this.$message.success("操作成功！");
              this.$emit("update");
              this.$emit("destroy");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          this.confirmLoading = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.data-form-box /deep/.fixed-label-width .ant-form-item .ant-form-item-label {
  width: 100px;
}
.order-info {
  color: #ff6f00;
  margin: 0px 2px 10px;
  padding: 5px;
  background: #fff4de;
  border-radius: 3px;
  margin-left: 100px;
  display: flex;
  width: calc(95.5% - 100px);
  .name {
    width: 100px;
  }
}
.total-info {
  width: 95%;
  text-align: right;
  span {
    color: #f00;
    font-size: 14px;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
